import { Box, CircularProgress, Typography } from "@mui/material";
import IMessage from "../../../../interface/IMessage";
import RenderMessageContent from "../renderMessageContent/renderMessageContent";
import React from "react";
import MessageUser from "../../../atoms/text/messageUser.styled";
import RenderMessage from "../renderMessage/renderMessage";

const RenderMessageUser = ({
  message,
}: {
  message: IMessage;
}): React.JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <MessageUser>
        {message.text && <RenderMessage message={message} />}
        {message.content && (
          <RenderMessageContent content={message.content} sender="user" />
        )}
      </MessageUser>

      {(message.timeStamp || message.sending) && (
        <Typography
          sx={{
            pb: message.timeStamp === null ? 0 : 1,
            color: (theme) =>
              theme.palette.widgetStyles.userChatBubble.textColor,
          }}
          variant="caption"
          color="initial"
        >
          {message.timeStamp}

          {message.sending && (
            <CircularProgress
              sx={{
                ml: 1,
              }}
              size="10px"
            />
          )}
        </Typography>
      )}
    </Box>
  );
};

export default RenderMessageUser;
